<template>
  <div class="esign-failure-container" v-if="show">
    <weex-image
      src="https://image4.owler.com/logo/ezcred_owler_20170518_222154_original.png"
      alt="EzCred"
      style="width: 200px;height: 50px"></weex-image>

    <weex-text class="font-size-xl margin-top-10">Please try again</weex-text>

    <weex-text class="margin-top-5">
      <span
        v-if="reasonCode"
        class="font-size-sm">{{reasonCode}}
      </span>
      <span
        v-if="reason"
        class="font-size-sm">{{reason}}
      </span>
    </weex-text>
  </div>
</template>

<script>
  export default {
    name: "EsignFailureView",
    props: {
      reasonCode: {
        type: String,
        default: ""
      },
      reason: {
        type: String,
        default: ""
      },
      show: {
        type: Boolean,
        required: true,
        default: false
      }
    }
  }
</script>

<style scoped>

  .esign-failure-container {
    margin: 20px auto;
    position: relative;
    background: #F9F9F9;
    padding: 10px;
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2), 0 5px 5px 0 rgba(0, 0, 0, 0.24);
  }

</style>
